import { useTranslation } from "react-i18next";
import { CreateTaskForm } from "./CreateTaskForm";
import { useUpdateTask } from "@/hooks/tasks/useTasks";

interface EditTaskModalProps {
  task: any;
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
}

export const EditTaskModal = ({ task, isOpen, onClose, onSave }: EditTaskModalProps) => {
  const { t } = useTranslation();
  const updateTaskMutation = useUpdateTask();

  const handleSubmit = async (taskData: any) => {
    try {
      await updateTaskMutation.mutateAsync({
        id: task.id,
        ...taskData
      });
      onSave();
    } catch (error) {
      console.error("Failed to update task:", error);
    }
  };

  return (
    <CreateTaskForm
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      isLoading={updateTaskMutation.isPending}
      initialData={task}
      isEditing={true}
    />
  );
};
